import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

const state = {
    /**
     * Conterrà i dati che arrivano dall'endpoint,
     * strutturati nelle categorie:
     * { appetisers: [...], pizza: [...], pasta: [...], desserts: [...], drinks: [...] }
     */
    all: {
        appetisers: [],
        pizza: [],
        pasta: [],
        desserts: [],
        drinks: []
    }
};

const getters = {
    /**
     * Filtra i piatti in base agli ingredienti e ai filtri booleani.
     * Ora accetta un ulteriore parametro "lang" (default "fr").
     */
    filterByIngredients: (state) => (course_key, ingredients, filters, lang = 'fr') => {
        if (!state.all[course_key]) return [];

        // Funzione di utilità per i filtri booleani
        const passFilters = (dish) => {
            if (filters.sansPorc === true && dish.has_pork === true) return false;
            if (filters.vegan === true && dish.is_vegan !== true) return false;
            if (filters.vegetarien === true && dish.is_vegetarian !== true) return false;
            return true;
        };

        return state.all[course_key].filter((dish) => {
            if (!passFilters(dish)) return false;

            // Usa la versione tradotta degli ingredienti se disponibile
            const dishIngredients = (dish.i18n_ingredients &&
                dish.i18n_ingredients[lang] && dish.i18n_ingredients[lang].length > 0)
                ? dish.i18n_ingredients[lang].map(ing => ing.trim().toLowerCase())
                : (dish.ingredients ? dish.ingredients.map(ing => ing.trim().toLowerCase()) : []);

            if (ingredients.length === 0) return true;

            return ingredients.every(ing => dishIngredients.includes(ing.toLowerCase()));
        });
    },

    /**
     * Estrae l'elenco di tutti gli ingredienti unici dalla lista di piatti,
     * utilizzando la traduzione se disponibile.
     */
    ingredients: () => (main_list, lang = 'fr') => {
        let ingredients = [];
        if (main_list && main_list.length > 0) {
            main_list.forEach((dish) => {
                let dishIngredients = (dish.i18n_ingredients &&
                    dish.i18n_ingredients[lang] &&
                    dish.i18n_ingredients[lang].length > 0)
                    ? dish.i18n_ingredients[lang]
                    : (dish.ingredients || []);
                dishIngredients = dishIngredients.map(ing => ing.trim()).filter(i => i !== '');
                ingredients.push(...dishIngredients);
            });
        }
        return Array.from(new Set(ingredients)).sort();
    }
};

const mutations = {
    /**
     * Salva il JSON (ritornato dall'API) all'interno dello state `all`.
     */
    SET_MENU(state, menuData) {
        // menuData dovrebbe essere un oggetto con le chiavi appetisers, pizza, ecc.
        state.all = menuData;
    }
};

const actions = {
    /**
     * Chiama l'endpoint e committa la mutation per salvare i dati.
     */
    async fetchMenu({ commit }) {
        try {
            const response = await axios.get('https://book.osolemioliege.be/api/menu');
            commit('SET_MENU', response.data);
        } catch (error) {
            console.error('Errore durante fetchMenu:', error);
            // gestisci eventuali errori (toast, alert, ecc.)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};